<div class="flex justify-center my-8">
  <div
    id="dropdown-component"
    class="max-md:!rounded-full max-md:mx-6"
    [ngStyle]="{ 'width.%': wi }"
  >
    <div class="selected flex justify-between" (click)="toggleMenu()">
      <div class="flex w-52 mt-4 mb-4 mr-4">
        <i class="ie-content-menu-icon"></i>
        <p class="text-xl font-medium mr-4">فهرست محتوا</p>
      </div>
      <div class="flex ml-4 mt-4 mb-4">
        <i class="ie-content-menu-open" *ngIf="!iconActive"></i>
        <i class="ie-content-menu-close" *ngIf="iconActive"></i>
      </div>
    </div>
    <div class="menu-wrapper">
      <ul #listElem>

        <li *ngFor="let item of hTagText">
          <div class="divider"></div>
          <div class="flex flex-col justify-around">
            <button
             name="scrollToId"
             type="submit"
             aria-label="انتخاب آیتم"
             (click)="scrollToId(item.id)"
             class="text-right">
              <p class="flex title-menu text-base lg:!text-xl">
                {{ item.text }}
              </p>
            </button>
          </div>
        </li>

      </ul>
    </div>
  </div>
</div>
